<nz-table [nzData]="data" [nzBordered]="true" [nzSize]="'middle'" [nzPagination]="false" [nzShowPagination]="false">
    <thead>
        <tr>
            <th>Key</th>
            <th nzWidth="120px">Order</th>
            <th nzWidth="100px">Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of data; let i = index">
            <td>
                <ng-container *ngIf="item.isNew; else readOnlyKey">
                    <nz-select *ngIf="eventCategoriesSource" [(ngModel)]="item.key" style="width: 200px;"
                        [nzOptions]="eventCategoriesSource" nzShowSearch nzAllowClear
                        nzPlaceHolder="Select category"></nz-select>
                </ng-container>
                <ng-template #readOnlyKey>
                    <span>{{ item.key }}</span>
                </ng-template>
            </td>
            <td>
                <input nz-input [(ngModel)]="item.order" type="number" style="width: 80px;" />
            </td>
            <td>
                <button nz-button nzType="link" (click)="updateAttachedInfo({ id: id, order: item.order }, item.key)">
                    <i class="fas fa-fw fa-floppy-disk"></i>
                </button>
                <button nz-button nzType="link" nzDanger (click)="removeAttachedItem(id, item.key)">
                    <i class="fas fa-fw fa-trash"></i>
                </button>
            </td>
        </tr>
    </tbody>
</nz-table>


<!-- Add Row Button -->
<div style="margin-top: 16px;">
    <button nz-button nzType="dashed" (click)="addRow()">Add Row</button>
</div>